import { createResourceLocatorString, pathByRouteName } from './routes';

const channelHref = (routeConfiguration, variant) =>
  pathByRouteName('CMSPage', routeConfiguration, { pageId: variant });

/**
 * Build a search-page href filtered to the given category levels.
 *
 * @param {Array} routeConfiguration
 * @param {Object} categoryIds
 * @param {string} [categoryIds.level1]
 * @param {string} [categoryIds.level2]
 * @param {string} [categoryIds.level3]
 * @returns {string}
 */
export const buildCategorySearchHref = (routeConfiguration, categoryIds = {}) => {
  const { level1, level2, level3 } = categoryIds;
  const searchParams = {};
  if (level1) {
    searchParams.pub_categoryLevel1 = level1;
  }
  if (level2) {
    searchParams.pub_categoryLevel2 = level2;
  }
  if (level3) {
    searchParams.pub_categoryLevel3 = level3;
  }
  return createResourceLocatorString('SearchPage', routeConfiguration, {}, searchParams);
};

/**
 * Build breadcrumb items for a Racing Theme listing detail page.
 *
 * @param {Object} params
 * @param {Array} routeConfiguration
 * @param {'shop'|'book'|'partner'} params.variant
 * @param {string} params.channelLabel
 * @param {string|null} [params.level1Id]
 * @param {string|null} [params.level2Id]
 * @param {string|null} [params.level3Id]
 * @param {string|null} [params.cat1Name]
 * @param {string|null} [params.cat2Name]
 * @param {string|null} [params.cat3Name]
 * @param {string} params.currentLabel
 * @returns {Array<{label: string, href: string|null}>}
 */
export const buildListingBreadcrumbs = (
  routeConfiguration,
  {
    variant,
    channelLabel,
    level1Id,
    level2Id,
    level3Id,
    cat1Name,
    cat2Name,
    cat3Name,
    currentLabel,
  }
) => {
  const breadcrumbs = [
    { label: 'Home', href: pathByRouteName('LandingPage', routeConfiguration) },
    {
      label: channelLabel,
      href: channelHref(routeConfiguration, variant),
    },
  ];

  if (cat1Name && cat1Name.toLowerCase() !== channelLabel.toLowerCase() && level1Id) {
    breadcrumbs.push({
      label: cat1Name,
      href: buildCategorySearchHref(routeConfiguration, { level1: level1Id }),
    });
  }
  if (cat2Name && level2Id) {
    breadcrumbs.push({
      label: cat2Name,
      href: buildCategorySearchHref(routeConfiguration, {
        level1: level1Id,
        level2: level2Id,
      }),
    });
  }
  if (cat3Name && level3Id) {
    breadcrumbs.push({
      label: cat3Name,
      href: buildCategorySearchHref(routeConfiguration, {
        level1: level1Id,
        level2: level2Id,
        level3: level3Id,
      }),
    });
  }

  breadcrumbs.push({ label: currentLabel, href: null });
  return breadcrumbs;
};
